// Appointment.statuses enum values, shared by the table and the calendar so the
// two views never drift apart on colour or wording.
// Foregrounds are the design's darker, higher-contrast set -- these are data
// states, so they stay fixed across the ten themes.
export const STATUS_COLORS = {
  0: '#B98900', // unconfirmed - shares the upcoming amber
  1: '#41924E', // confirmed   - success
  2: '#D14B48', // canceled    - danger
  3: '#0277BD', // checked_in  - info
  4: '#41924E', // completed   - success
  5: '#B98900', // upcoming    - warning
  default: '#868e96', // secondary
};

// The pale fill each foreground sits on: chips, day-modal counter tiles and status
// badges. Paired with STATUS_COLORS above, never mixed across statuses.
export const STATUS_TINTS = {
  0: '#FFF6DB',
  1: '#E9F3EB',
  2: '#FFECEB',
  3: '#E3F4FD',
  4: '#E9F3EB',
  5: '#FFF6DB',
  default: '#F1F3F5',
};

export const statusColor = (status) => STATUS_COLORS[status] || STATUS_COLORS.default;
export const statusTint = (status) => STATUS_TINTS[status] || STATUS_TINTS.default;

export const STATUS_LABELS = {
  0: 'Unconfirmed',
  1: 'Confirmed',
  2: 'Canceled',
  3: 'Checked In',
  4: 'Completed',
  5: 'Upcoming',
};

export const statusLabel = (status) => STATUS_LABELS[status] || 'Unknown';

// Every status the calendar summarises: legend, day-modal counters and the modal's
// filter chips all read this list so they can never fall out of order. All six are
// here on purpose -- the day header's total sums every status, so omitting any would
// leave rows visible under "all" but unreachable by a filter chip, above counters
// that do not add up to the total printed beside them.
export const SUMMARY_STATUSES = [5, 1, 3, 2, 0, 4];

// The month legend is the shorter list on purpose. It only has to name the colours a
// day cell can actually paint, and the design shows four. SUMMARY_STATUSES stays at
// six because the day modal's counters and filter chips must cover every status the
// day total sums -- omitting one there would leave rows unreachable by any chip.
export const LEGEND_STATUSES = [5, 1, 3, 2];

// Wording lives in en.yml/id.yml, so components look up a label key rather than
// the hardcoded English in STATUS_LABELS.
export const STATUS_LABEL_KEYS = {
  0: 'status_unconfirmed',
  1: 'status_confirmed',
  2: 'status_canceled',
  3: 'status_checked_in',
  4: 'status_completed',
  5: 'status_upcoming',
};
